import {useEffect, useRef, useState} from 'react';

const useInactiveUserDetector = (timeout = 360000) => {
    // timeout default is 1 hour (3600000 milliseconds)
    const [isActive, setIsActive] = useState<boolean>(true);
    const timeoutRef = useRef<any>(null);

    const setInactive = () => {
        setIsActive(false);
    };

    const resetTimer = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(setInactive, timeout);
    };

    useEffect(() => {
        // Set up event listeners to reset the timer on user actions
        const handleActivity = () => {
            resetTimer();
        };

        // Set up event listeners
        document.addEventListener('mousemove', handleActivity);
        document.addEventListener('keypress', handleActivity);
        document.addEventListener('touchstart', handleActivity);

        // Set the initial timer
        resetTimer();

        // Cleanup function to remove event listeners and clear the timer
        return () => {
            clearTimeout(timeoutRef.current);
            document.removeEventListener('mousemove', handleActivity);
            document.removeEventListener('keypress', handleActivity);
            document.removeEventListener('touchstart', handleActivity);
        };
    }, [timeout]);

    return isActive;
};

export default useInactiveUserDetector;
